<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="primary--text mb-2 font-weight-bold">
          Filtrar
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="8" class="pr-sm-5 pr-0">
        <BaseFormAutocomplete
          id-element="filterEndorsement"
          placeholder="Tomador Matriz/Filial ou CNPJ"
          v-model="requestEndorsementFilter.filter"
          :items="currentTakerQuotation"
          hide-no-data
          item-text="nome_fantasia"
          item-value="id"
          template-taker
          validate-on-blur
          @keyup="searchInput"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <p class="primary--text font-weight-bold body-2 mb-0">
          Status
        </p>
        <v-checkbox
          v-model="requestEndorsementFilter.aprovada"
          label="Aprovada"
          class="d-inline-block pr-5 ma-0 policy-table__checkbox pt-0"
          dense
        />
        <v-checkbox
          v-model="requestEndorsementFilter.pendente_aprovacao"
          label="Pendente Aprovação"
          dense
          class="d-inline-block ma-0 policy-table__checkbox pt-0"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pr-md-5 pr-0">
        <BaseSelect
          placeholder="Tipos de Filtros"
          :items="listTypesFilterRequestEndorsement"
          v-model="requestEndorsementFilter.tipo"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col
        cols="12"
        sm="3"
        md="2"
        class="pr-md-5 pr-0"
        v-if="indexIntervalDateFilter > -1"
      >
        <BaseFilter
          v-model="requestEndorsementFilter.inicio"
          :textPlaceholder="'DD/MM/AAAA'"
          outlined
          dense
          v-facade="maskDate"
          :rules="[dateTermValid, requiredInput]"
          validate-on-blur
          required
        />
      </v-col>
      <v-col
        cols="12"
        sm="3"
        md="2"
        class="pr-md-5 pr-0"
        v-if="indexIntervalDateFilter > -1"
      >
        <BaseFilter
          v-model="requestEndorsementFilter.fim"
          :textPlaceholder="'DD/MM/AAAA'"
          outlined
          dense
          v-facade="maskDate"
          :rules="[dateTermValid, requiredInput]"
          validate-on-blur
          required
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        class="pr-md-5 pr-0"
        v-if="indexIntervalDateFilter == -1"
      >
        <BaseSelect
          placeholder="Selecione"
          :items="currentSelectFilterRequestEndorsement"
          v-model="requestEndorsementFilter.valor"
          v-if="indexSelectFilter > -1"
          :multiple="true"
          item-text="nome"
          item-value="id"
          required
          :rules="[requiredInput]"
        />
        <BaseFilter
          v-model="requestEndorsementFilter.valor"
          :textPlaceholder="'Informe'"
          outlined
          dense
          v-if="indexNormalFilter > -1"
          required
          :rules="[requiredInput]"
        />
        <BaseFormAutocomplete
          id-element="autocompleteQuotation"
          placeholder="Autocomplete"
          v-model="requestEndorsementFilter.valor"
          :items="currentAutoCompleteFilterQuotation"
          hide-no-data
          item-text="nome"
          item-value="id"
          validate-on-blur
          @keyup="searchInput"
          v-if="indexAutocompleteFilter > -1 && indexAutocompleteFilter != 3"
          :return-object="true"
          required
          :rules="[requiredInput]"
        />
        <BaseFormAutocomplete
          id-element="autocompleteQuotation"
          placeholder="Autocomplete"
          v-model="requestrequestEndorsementFilter.valor"
          :items="currentAutoCompleteFilterQuotation"
          hide-no-data
          item-text="numero"
          item-value="id"
          validate-on-blur
          @keyup="searchInput"
          v-if="indexAutocompleteFilter == 3"
          :return-object="true"
          required
          :rules="[requiredInput]"
        />
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="6" md="2" class="pr-0 pb-5 pb-md-0 pr-sm-3">
        <BaseButton
          v-html="'PESQUISAR'"
          class="secondary white--text"
          width="100%"
          @click="searchByFilter"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pb-5 pb-md-0">
        <BaseButton
          v-html="'LIMPAR'"
          color="secondary"
          width="100%"
          outlined
          @click="resetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <BaseDataTable
          :headers="header"
          :items="requestEndorsements.items"
          no-data-text="Nenhuma Solicitação de endosso foi encontrada"
          :options.sync="options"
          :server-items-length="requestEndorsements.total_count"
          @click:row="redirectToRequestEndorsement"
        >
          <template v-slot:[`item.tipo`]="{ item }">
            {{ item.tipo.nome }}
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            {{ item.situacao.nome }}
          </template>
        </BaseDataTable>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
const tableHeaders = [
  { text: "N° da Solicitação de Endosso", value: "numero", sortable: true },
  {
    text: "Tipo",
    value: "tipo",
    sortable: true
  },
  {
    text: "N° Apólice",
    value: "apolice.numero",
    sortable: true
  },
  {
    text: "Tomador Matriz/Filial",
    value: "apolice.tomador.nome_fantasia",
    sortable: false
  },
  { text: "Status", value: "situacao", sortable: true }
];
const MOCK_OPTIONS = {
  groupBy: [],
  groupDesc: [],
  itemsPerPage: 5,
  multiSort: false,
  mustSort: false,
  page: 1,
  sortBy: [],
  sortDesc: []
};
const MOCK_FILTER = {
  nao_vigente: false,
  vigente: false,
  valor: null,
  tipo: {
    nome: null,
    id: null
  },
  filter: null,
  inicio: null,
  fim: null
};
import {
  asMoneyString,
  formatDateToDDMMYYYY,
  formatIsoDateToDDMMYYYY
} from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { maskDate } from "@/utils/masks.js";
import { dateTermValid, requiredInput } from "@/utils/rules.js";
import _ from "lodash";
import FilterEndorsementMixin from "../mixins/FilterEndorsementMixin";
export default {
  data() {
    return {
      requestEndorsementFilter: null,
      currentFilter: null,
      header: tableHeaders,
      asMoneyString,
      options: MOCK_OPTIONS,
      maskDate,
      formatDateToDDMMYYYY,
      formatIsoDateToDDMMYYYY,
      dateTermValid,
      requiredInput
    };
  },
  watch: {
    options: {
      handler(value) {
        this.fetchRequestEndorsement(
          this.getPayload(value, this.currentFilter)
        );
      },
      deep: true
    },
    "requestEndorsementFilter.tipo"() {
      // Toda vez que trocar o filtro, tem que resertar o valor antigo
      this.requestEndorsementFilter.valor = null;
      this.requestEndorsementFilter.incio = null;
      this.requestEndorsementFilter.fim = null;
      this.resetCurrentFilters("request-endorsement");
      if (this.indexSelectFilter > -1)
        this.fetchSelectFilter(this.indexSelectFilter, "request-endorsement");
    }
  },
  mixins: [LoadingRequest, FilterEndorsementMixin],
  created() {
    this.initialize();
  },
  computed: {
    ...mapState("quotation", [
      "currentAutoCompleteFilterQuotation",
      "currentTakerQuotation",
      "currentSelectFilterRequestEndorsement"
    ]),
    ...mapState("endorsement", ["requestEndorsements"]),
    indexAutocompleteFilter() {
      return this.MOCK_AUTOCOMPLETE_FILTER.indexOf(
        this.requestEndorsementFilter.tipo.nome
      );
    },
    indexSelectFilter() {
      return this.MOCK_SELECT_FILTER.indexOf(
        this.requestEndorsementFilter.tipo.nome
      );
    },
    indexNormalFilter() {
      return this.MOCK_NORMAL_FILTER.indexOf(
        this.requestEndorsementFilter.tipo.nome
      );
    },
    indexIntervalDateFilter() {
      return this.MOCK_INTERVAL_DATE_FILTER.indexOf(
        this.requestEndorsementFilter.tipo.nome
      );
    },
    requiredValidTaker() {
      return (
        this.validateFilterTaker() || "É preciso selecionar um tomador válido"
      );
    }
  },
  methods: {
    ...mapActions("endorsement", ["requestListRequestEndorsement"]),
    initialize() {
      this.currentFilter = _.cloneDeep(MOCK_FILTER);
      this.requestEndorsementFilter = _.cloneDeep(MOCK_FILTER);
    },
    fetchRequestEndorsement(payload) {
      this.withLoading(this.requestListRequestEndorsement(payload));
    },
    searchByFilter() {
      if (!this.validate()) return;     
      this.requestEndorsementFilter.situacao = "";
      if (this.requestEndorsementFilter.aprovada) {
        this.requestEndorsementFilter.situacao += "aprovada";
      };
      if (this.requestEndorsementFilter.pendente_aprovacao) {
        this.requestEndorsementFilter.situacao += (this.requestEndorsementFilter.aprovada?",":"")+"pendente_aprovacao";
      };
      this.currentFilter = _.cloneDeep(this.requestEndorsementFilter);
      this.fetchRequestEndorsement(
        this.getPayload(this.options, this.currentFilter)
      );
    },
    resetFilter() {
      this.options = _.cloneDeep(MOCK_OPTIONS);
      this.requestEndorsementFilter = _.cloneDeep(MOCK_FILTER);
      this.currentFilter = _.cloneDeep(MOCK_FILTER);
      this.fetchRequestEndorsement(
        this.getPayload(this.options, this.currentFilter)
      );
    },
    validate() {
      const validateForm = this.requestEndorsementFilter.tipo.id
        ? this.$refs.form.validate()
        : true;
      return validateForm;
    },
    validateFilterTaker() {
      return (
        !this.requestEndorsementFilter.filter ||
        Boolean(this.requestEndorsementFilter.filter?.id)
      );
    },
    redirectToRequestEndorsement(item) {
      this.$router.push({
        name: "edit endorsement request policy",
        params: { endosso: item.id, id: item.apolice.id }
      });
    }
  }
};
</script>
